// eslint-disable-next-line max-len
var TIME_LOCATION_MUSEUM = 'M31,30H29V17h1V13h0a1,1,0,0,0,0-2H23.5A7.49,7.49,0,0,0,17,3.57V1a1,1,0,0,0-2,0V3.57A7.49,7.49,0,0,0,8.5,11H2a1,1,0,0,0,0,2H2v4H3V30H1a1,1,0,0,0,0,2H31a1,1,0,0,0,0-2ZM8,17H13.5V30H8Zm8.49,0V30h-1V17Zm2,0H24V30H18.5ZM27,30H26V17h1ZM12.11,7.11A5.47,5.47,0,0,1,16,5.5h0A5.5,5.5,0,0,1,21.5,11h-11A5.49,5.49,0,0,1,12.11,7.11ZM28,13v2H4V13ZM6,17V30H5V17Z';

export { TIME_LOCATION_MUSEUM };
//# sourceMappingURL=TIME_LOCATION_MUSEUM.js.map
